import { Breadcrumbs, CrumbProps } from "@amzn/stencil-react-components/breadcrumbs";
import { ButtonVariant } from "@amzn/stencil-react-components/button";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { Button } from "@amzn/uxm-stencil-react-components/lib/src/stencil/button";
import { SearchField } from "@amzn/uxm-stencil-react-components/lib/src/stencil/search-field";
import { PageMainContainer } from "common/components/PageMainContainer/PageMainContainer";
import { Paths } from "common/paths/paths";
import { getString } from "common/uistringlabels/uiStringUtils";
import { GlobalStats } from "lib/models/user-insights-models";
import React, { FC } from "react";
import { useHistory } from "react-router-dom";

import { UseCaseBrowseTouchpoint } from "../constants";
import { CommunityStats } from "./CommunityStats";

interface BrowseHeroProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  globalStats: GlobalStats | null;
}

export const BrowseHero: FC<BrowseHeroProps> = ({ searchQuery, onSearchChange, globalStats }) => {
  const history = useHistory();

  return (
    <div className="use-case-browse-page__gradient-back">
      <PageMainContainer>
        <Row>
          <Breadcrumbs
            crumbs={[
              { title: getString("logoText"), url: "/" },
              { title: getString("aiForMe.title"), url: "/aiforme" },
              { title: getString("useCases.browsePage.breadcrumbUseCases") },
            ]}
            onCrumbClick={(e, crumb: CrumbProps) => {
              if (crumb.url) {
                e.preventDefault();
                history.push(crumb.url);
              }
            }}
          />
        </Row>
        <Row justifyContent="space-between" alignItems="flex-end" style={{ minHeight: "350px" }}>
          <Col flex={2}>
            <Text fontSize="T500" fontWeight="bold" style={{ paddingBottom: 20 }}>
              {getString("useCases.browsePage.title")}
            </Text>

            <CommunityStats
              useCases={globalStats?.totalUseCases ?? 0}
              contributors={globalStats?.totalContributors ?? 0}
              aiTools={globalStats?.totalAiTools ?? 0}
            />

            <Text fontSize="T200" color="var(--st-dt-color-text-secondary)" style={{ padding: "16px 0" }}>
              {getString("useCases.browsePage.description")}
            </Text>

            <Row columnGap={20} padding={[0, 0, 18, 0]} width="100%">
              <SearchField
                type="text"
                touchpoint={UseCaseBrowseTouchpoint.Search}
                data-cy={UseCaseBrowseTouchpoint.Search}
                placeholder={getString("useCases.browsePage.searchPlaceholder")}
                query={searchQuery}
                onChange={onSearchChange}
                shouldShowListOnNoResults={false}
              />
            </Row>

            <Row gridGap="S300" padding={[16, 0, 45, 0]}>
              <Button
                variant={ButtonVariant.Primary}
                onClick={() => history.push(Paths.aiForMeUseCaseContribute.url)}
                touchpoint={UseCaseBrowseTouchpoint.Contribute}
              >
                {getString("useCases.browsePage.contributeButton")}
              </Button>
              <Button
                variant={ButtonVariant.Secondary}
                onClick={() => history.push(Paths.aiForMeUseCaseDashboard.url)}
                touchpoint={UseCaseBrowseTouchpoint.Dashboard}
              >
                {getString("useCases.browsePage.checkContributionsButton")}
              </Button>
            </Row>
          </Col>
          <Col flex={1}>
            <img
              src="/img/aiforme-people-animated.svg"
              alt="People sharing AI use cases"
              style={{ maxWidth: 468, width: "100%", height: "auto" }}
            />
          </Col>
        </Row>
      </PageMainContainer>
    </div>
  );
};
